import React from "react";
import PropTypes from "prop-types";
import Table from "components/Table/Table.js";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import CardHeader from "components/Card/CardHeader.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
const useStyles = makeStyles(styles);

function DeficitIndicator({ value, classes }) {
  return (
    <h4>
      <b>
        {value > 0 ? (
          <span className={classes.dangerText}>
            <ArrowDownward className={classes.upArrowCardCategory} />
            {value.toFixed(2)}
          </span>
        ) : (
          <span className={classes.successText}>
            <ArrowUpward className={classes.upArrowCardCategory} />
            {Math.abs(value).toFixed(2)}
          </span>
        )}
      </b>
    </h4>
  );
}

DeficitIndicator.propTypes = {
  value: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
};

export default function DeficitReport(props) {
  const classes = useStyles();
  const { cropNeeds, fertilizer } = props;

  const fertN = fertilizer ? (fertilizer.contributionN ?? fertilizer.quantityKg * fertilizer.type.unitN) : 0;
  const fertP = fertilizer ? (fertilizer.contributionP ?? fertilizer.quantityKg * fertilizer.type.unitP) : 0;
  const fertK = fertilizer ? (fertilizer.contributionK ?? fertilizer.quantityKg * fertilizer.type.unitK) : 0;

  const remainingN = cropNeeds.nitrogen.deficit - fertN;
  const remainingP = cropNeeds.phosphorus.deficit - fertP;
  const remainingK = cropNeeds.potassium.deficit - fertK;

  const fertilizerRow = fertilizer
    ? [
        <p key={1}><b>{"Fertilizer Provides"}</b></p>,
        fertN.toFixed(2),
        fertP.toFixed(2),
        fertK.toFixed(2),
        "—",
        "—",
        "—",
        "—",
      ]
    : null;

  const deficitLabel = fertilizer ? "Remaining Deficit" : "Deficit";

  const tableData = [
    [
      <p key={1}><b>{"Soil Available"}</b></p>,
      cropNeeds.nitrogen.soilAvailableAmount.toFixed(2),
      cropNeeds.phosphorus.soilAvailableAmount.toFixed(2),
      cropNeeds.potassium.soilAvailableAmount.toFixed(2),
      cropNeeds.moisture.soilAvailableAmount.toFixed(2),
      cropNeeds.conductivity.soilAvailableAmount.toFixed(2),
      cropNeeds.temperature.soilAvailableAmount.toFixed(2),
      cropNeeds.ph.soilAvailableAmount.toFixed(2),
    ],
    [
      <p key={1}><b>{"Crop Requirement"}</b></p>,
      cropNeeds.nitrogen.cropNeed.toFixed(2),
      cropNeeds.phosphorus.cropNeed.toFixed(2),
      cropNeeds.potassium.cropNeed.toFixed(2),
      cropNeeds.moisture.cropNeed.toFixed(2),
      cropNeeds.conductivity.cropNeed.toFixed(2),
      cropNeeds.temperature.cropNeed.toFixed(2),
      cropNeeds.ph.cropNeed.toFixed(2),
    ],
    ...(fertilizerRow ? [fertilizerRow] : []),
    [
      <h4 key={1}>
        <b>
          {deficitLabel + " "}
          <span className={classes.dangerText}>
            <ArrowDownward className={classes.upArrowCardCategory} />
          </span>
          {"| surplus"}
          <span className={classes.successText}>
            <ArrowUpward className={classes.upArrowCardCategory} />
          </span>
        </b>
      </h4>,
      <DeficitIndicator key={2} value={fertilizer ? remainingN : cropNeeds.nitrogen.deficit} classes={classes} />,
      <DeficitIndicator key={3} value={fertilizer ? remainingP : cropNeeds.phosphorus.deficit} classes={classes} />,
      <DeficitIndicator key={4} value={fertilizer ? remainingK : cropNeeds.potassium.deficit} classes={classes} />,
    ],
  ];

  const headerTitle = fertilizer
    ? `Deficit Report — ${fertilizer.type.name}`
    : "Nutrient Deficiency Report";

  return (
    <Card>
      <CardHeader color="danger">
        <h4 className={classes.cardTitleWhite}>{headerTitle}</h4>
      </CardHeader>
      <CardBody>
        <Table
          tableHeaderColor="warning"
          tableHead={["", "Nitrogen(Kg)", "Phosphorus(Kg)", "Potassium(Kg)", "Moisture", "Conductivity", "Temperature", "PH"]}
          tableData={tableData}
        />
      </CardBody>
    </Card>
  );
}

DeficitReport.propTypes = {
  cropNeeds: PropTypes.object.isRequired,
  fertilizer: PropTypes.object,
};
